import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/drawer/drawer-end.styles.ts
var drawer_end_styles_default = r` :host { display: block; } .drawer-end { opacity: 0; max-height: 0; overflow: hidden; transition: 250ms ease-out all; } .drawer-end--open { opacity: 1; max-height: 1000px; } .drawer-end * { white-space: nowrap; } `;

export {
  drawer_end_styles_default
};
